import { DialogActions,  Button} from '@mui/material';
export const CustomFormFooter = (props:any) => {

  const { 
    confirmText, onConfirm, cancelText, onCancel, cancelColor, confirmColor, className, backgroundColor, buttonType,
    secondaryText, onSecondaryConfirm, clearState
  } = props;

    return (
      <DialogActions className={className || "modal-footer"} sx={{ position: 'sticky', gap: 1, px: 3, py: 2 }}>
        {
          cancelText && (
            <Button onClick={()=>{onCancel && onCancel(); clearState && clearState()}} size="small" color={cancelColor || "primary"} variant="outlined" className={backgroundColor || ''}>
              {cancelText}
            </Button>
          )
        }
        {
          confirmText && (
            <Button onClick={onConfirm} type={buttonType} size="small" color={confirmColor || "primary"} autoFocus variant="contained">
              {confirmText}
            </Button>
          )
        }
        {
          secondaryText && (
            <Button onClick={onSecondaryConfirm} type={buttonType} size="small" color="error" autoFocus variant="outlined">
              {secondaryText}
            </Button>
          )
        }
      </DialogActions>
    )
}
